import { httpRequest } from '@/utils/request';

// 异步获取浙政钉分组列表
export function getZzdGroupListPromise(id) {
  return httpRequest.get('/manager/user/child/dept?id=' + id);
}

// 模糊查询浙政钉分组
export function searchZzdGroupListPromise(param) {
  return httpRequest.get('/manager/user/dept/level/search?key_word=' + param);
}
